import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Cash denomination chip.
 * Unselected: full-chip tap emits `add`. Selected: only +/- change the count.
 * Selected state (border, steppers, badge) only when `count >= 1` — count 0 deselects.
 */
@Component({
  selector: 'app-cash-preset-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cash-preset-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cash-preset-button.component.scss'],
})
export class CashPresetButtonComponent {
  @Input({ required: true }) amount!: number;
  @Input() count = 0;

  @Output() add = new EventEmitter<number>();
  @Output() increment = new EventEmitter<number>();
  @Output() decrement = new EventEmitter<number>();

  get safeCount(): number {
    if (!Number.isFinite(this.count) || this.count <= 0) {
      return 0;
    }
    return Math.floor(this.count);
  }

  get isSelected(): boolean {
    return this.safeCount >= 1;
  }

  /** Count badge once the denomination has been tapped at least once. */
  get showChip(): boolean {
    return this.safeCount >= 1;
  }

  get displayLabel(): string {
    return `$${this.amount}`;
  }

  onAdd(): void {
    if (!Number.isFinite(this.amount) || this.amount <= 0) {
      return;
    }
    this.add.emit(this.amount);
  }

  onIncrement(event: Event): void {
    event.stopPropagation();
    if (!Number.isFinite(this.amount) || this.amount <= 0) {
      return;
    }
    this.increment.emit(this.amount);
  }

  onDecrement(event: Event): void {
    event.stopPropagation();
    if (!Number.isFinite(this.amount) || this.amount <= 0) {
      return;
    }
    this.decrement.emit(this.amount);
  }
}
